import PrincipalMessage from "../components/pages/PrincipalMessage";

export default PrincipalMessage;
